import { Helmet } from "react-helmet-async";

import { useLanguage } from "../../hooks/use-language";

export function Head() {
  const { language, dictionary } = useLanguage();

  return (
    <Helmet htmlAttributes={{ lang: language }}>
      <meta name="description" content={dictionary.content} />

      <link
        rel="preload"
        as="image"
        href="https://amanda.s3.eu-west-1.amazonaws.com/main-1280.jpg"
        imagesrcset="https://amanda.s3.eu-west-1.amazonaws.com/main-671.jpg 671w, https://amanda.s3.eu-west-1.amazonaws.com/main-954.jpg 954w, https://amanda.s3.eu-west-1.amazonaws.com/main-1280.jpg 1280w, https://amanda.s3.eu-west-1.amazonaws.com/main-1440.jpg 1440w, https://amanda.s3.eu-west-1.amazonaws.com/main-1920.jpg 1920w, https://amanda.s3.eu-west-1.amazonaws.com/main-2880.jpg 2880w"
        imagesizes="100vw"
        fetchpriority="high"
      />

      <meta property="og:title" content="Amanda Onnela" />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={dictionary.content} />
      <meta property="og:url" content="https://amandaonnela.com/" />
      <meta
        property="og:image"
        content="https://amanda.s3.eu-west-1.amazonaws.com/main-1280.jpg"
      />
      <meta property="og:site_name" content="Amanda Onnela" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Amanda Onnela" />
      <meta name="twitter:description" content={dictionary.content} />
      <meta
        name="twitter:image"
        content="https://amanda.s3.eu-west-1.amazonaws.com/main-671.jpg"
      />
    </Helmet>
  );
}
